"use client";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Icon } from "@/components/ui/icon";
import { RANGE_MODE_OPTIONS } from "@/features/search/lib/filter-options";

export function RangeModeDropdown({
  value,
  onChange,
}: {
  value: "exact" | "area";
  onChange: (v: "exact" | "area") => void;
}) {
  const current = RANGE_MODE_OPTIONS.find((o) => o.value === value) ?? RANGE_MODE_OPTIONS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="flex items-center gap-0.5 cursor-pointer">
          <span className="text-[11px] tracking-[-0.1px] text-ai whitespace-nowrap">
            {current.label}
          </span>
          <Icon name="IconChevronDownMedium" size={11} className="text-ai" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={2} className="w-[140px]">
        <DropdownMenuRadioGroup
          value={value}
          onValueChange={(v) => onChange(v as "exact" | "area")}
        >
          {RANGE_MODE_OPTIONS.map((opt) => (
            <DropdownMenuRadioItem key={opt.value} value={opt.value}>
              <span>{opt.label}</span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
